import { API_MEMBERS, AUTH_SESSION } from "../constants";
import { axiosDelete, axiosGet, axiosPatch, axiosPost, getAuthorization } from "../utils/axios";


const MemberApi = {
  getMember: async (paginationParams: any) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosGet(API_MEMBERS, { ...paginationParams }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getMember:", error);
        return error.response.data;
      });
  },

  createMember: async (name: string, email: string, password: string) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosPost(API_MEMBERS, { 'name': name, 'email': email, 'password': password }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error createMember:", error);
        return error.response.data;
      });
  },

  readMember: async (memberId: string) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosGet(`${API_MEMBERS}/${memberId}`, {}, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error readMember:", error);
        return error.response.data;
      });
  },

  updateMember: async (memberId: string, name: string, email: string, password: string) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    let data: Record<string, string> = {
      name: name,
      email: email
    };

    if (password) {
      data.password = password;
    }

    return await axiosPatch(`${API_MEMBERS}/${memberId}`, data, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error updateMember:", error);
        return error.response.data;
      });
  },

  deleteMember: async (memberId: string) => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosDelete(`${API_MEMBERS}/${memberId}`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleteMember:", error);
        return error.response.data;
      });
  },
};

export default MemberApi;
